import { Paper, styled } from '@mui/material'
import SnowflakeConnectionRoleDialog from 'features/connections/ui/ConnectionForm/DBConnectionForm/SnowflakeConnection/SnowflakeConnectionRoleDialog'
import useSnowflakeOAuth from 'features/connections/ui/ConnectionForm/DBConnectionForm/SnowflakeConnection/useSnowflakeOAuth'
import { useGetExternalIdps } from 'features/integrations/hooks/integrationsHooks'
import { useEffect, useState } from 'react'
import GettingStartedForm from './GettingStartedForm'
import isolinesbg from 'assets/img/isolinesbg.svg'
import WelcomeMessage from './WelcomeMessage'

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(5),
  width: '100%',
  height: '100%',
  backgroundImage: 'url(https://app.carto.com/new-background.webp)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  alignItems: 'center',
  justifyContent: 'center'
}))

const Modal = styled(Paper)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  maxHeight: theme.spacing(90),
  maxWidth: theme.spacing(155),
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: `url(${isolinesbg})`
}))
function GettingStarted() {
  const [showForm, setShowForm] = useState(false)
  const { data: externalIdps } = useGetExternalIdps()
  const defaultExternalIdp = externalIdps?.[0]

  const {
    startOAuth,
    handleOAuth,
    isOAuthLoading,
    oauthState,
    selectedRole,
    showRoleDialog,
    setShowRoleDialog,
    oauthError
  } = useSnowflakeOAuth(defaultExternalIdp)

  useEffect(() => {
    if (oauthState) {
      setShowForm(true)
    }
  }, [oauthState])

  return (
    <Root>
      <Modal>
        {!showForm && <WelcomeMessage onContinue={handleOAuth} loading={isOAuthLoading} error={oauthError} />}
        {showForm && (
          <GettingStartedForm
            oauthState={oauthState}
            defaultExternalIdp={defaultExternalIdp}
            onRequestNewOauth={handleOAuth}
            onCancel={() => setShowForm(false)}
            selectedRole={selectedRole}
          />
        )}
        <SnowflakeConnectionRoleDialog
          open={showRoleDialog}
          onCancel={() => setShowRoleDialog(false)}
          onConfirm={startOAuth}
        />
      </Modal>
    </Root>
  )
}

export default GettingStarted
